import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[scrollTo]'
})

export class ScrollToDirective {
  @Input() blockScroll = "end"

  constructor(private elRef: ElementRef) { }

  ngAfterViewInit(){
    this.elRef.nativeElement.scrollIntoView({behavior: 'smooth', block: this.blockScroll});
  }
}
